import { StorefrontApiError } from '../api/client';
import type { DiscountRefusal } from '../api/discountCode';

// Reads why the server refused the order's discount code, when that is why the order was refused.
export function refusedDiscount(error: unknown): DiscountRefusal | null {
  if (!(error instanceof StorefrontApiError)) return null;
  const details = error.details as { code?: unknown; reason?: unknown } | undefined;
  return details?.code === 'DISCOUNT_REFUSED' && typeof details.reason === 'string' ? (details.reason as DiscountRefusal) : null;
}
